import http from "../../utils/http";

export const getTaxpayerList = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/taxpayer/list`, params)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};


export const dataToManagement = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/management/to-management`, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};


export const getTaxpayerDownloadExcel = () => {
  return new Promise((resolve, reject) => {
    http
      .post(`/taxpayer/excel/download`, {}, {
        responseType: "arraybuffer",
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const taxpayerUploadExcel = (file) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/taxpayer/excel/upload`, file)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getTaxpayerSchedules = (companyIdx, params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/taxpayer/${companyIdx}/schedule/list`, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const addTaxpayerSchedule = (companyIdx, params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/taxpayer/${companyIdx}/schedule`, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });

};

export const removeTaxpayerSchedule = (companyIdx, idx) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/taxpayer/${companyIdx}/schedule/${idx}`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const editTaxpayerSchedule = (companyIdx, idx, params = {}) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/taxpayer/${companyIdx}/schedule/${idx}`, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const taxpayerScheduleCategoryList = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/taxpayer/schedule/category/list`, params)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const addTaxpayerScheduleCategory = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/taxpayer/schedule/category`, body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const editTaxpayerScheduleCategory = (idx, body) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/taxpayer/schedule/category/${idx}`, body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const deleteTaxpayerScheduleCategory = (data) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/taxpayer/schedule/category`, {
        data
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const taxpayerSynchronization = (idx) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/taxpayer/${idx}/synchronization`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

/** 추가 사이트정보 관리 */
export const addTaxpayerAddSiteInfo = (companyIdx, taxpayerIdx, body = {}) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/taxpayer/${companyIdx}/addsiteinfo/${taxpayerIdx}`, body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getTaxpayerAddSiteInfos = (companyIdx, taxpayerIdx) => {
  return new Promise((resolve, reject) => {
    http
      .get(`/taxpayer/${companyIdx}/addsiteinfo/${taxpayerIdx}`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getTaxpayerAddSiteInfo = (companyIdx, taxpayerIdx, postIdx) => {
  return new Promise((resolve, reject) => {
    http
      .get(`/taxpayer/${companyIdx}/addsiteinfo/${taxpayerIdx}/${postIdx}`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const editTaxpayerAddSiteInfo = (companyIdx, taxpayerIdx, postIdx, body = {}) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/taxpayer/${companyIdx}/addsiteinfo/${taxpayerIdx}/${postIdx}`, body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const deleteTaxpayerAddSiteInfo = (companyIdx, taxpayerIdx, postIdx) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/taxpayer/${companyIdx}/addsiteinfo/${taxpayerIdx}/${postIdx}`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const companiesCheckedList = () => {
  return new Promise((resolve, reject) => {
    http
      .get(`/taxpayer/companies/checkList`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const companiesToTaxpayer = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/taxpayer/companiesToTaxpayer`, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const addTaxpayerPersonInCharge = (body = {}) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/taxpayer/personincharge`, body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getTaxpayerPersonInChargeList = (taxpayerIdx) => {
  return new Promise((resolve, reject) => {
    http
      .get(`/taxpayer/personincharge/${taxpayerIdx}`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const editTaxpayerPersonInCharge = (postIdx, body = {}) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/taxpayer/personincharge/${postIdx}`, body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const deleteTaxpayerPersonInCharge = (postIdx, data) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/taxpayer/personincharge/${postIdx}`, { data })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const modeifyTaxpayerManagers = (params) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/taxpayer/managers`, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const taxpayerFired = (params) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/taxpayer/fired`, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};